export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-social-github-331e9205e2437c16a4a2a5e8dacc3ba7.svg";